module.exports = __webpack_public_path__ + "static/media/survive.6c520322.png";